import React, {memo} from 'react';
import {Link} from "react-router-dom";
import {Button, ButtonGroup} from "reactstrap";
import PropTypes from 'prop-types';

const SettingsColumn = memo(({feed, projectState}) => (
  <td width={"48%"} className="overflow-auto text-break">
    <div className="d-flex justify-content-center">
      <ButtonGroup aria-label="Settings" role="group" className="w-75">
        <Button disabled={!feed.status} className="p-3">
          <Link
            to={`/admin/companies/${projectState.companyId}/projects/${projectState.projectId}/data_sources/${feed.id}/edit`}>
            Settings
          </Link>
        </Button>
        <div className="bg-lavender-mist d-flex align-items-center">
          <div className="vertical-line"></div>
        </div>
        <Button disabled={!feed.status} className="p-3">
          <Link
            to={`/admin/companies/${projectState.companyId}/projects/${projectState.projectId}/data_sources/${feed.id}/mapping`}>
            Mapping
          </Link>
        </Button>
        <div className="bg-lavender-mist d-flex align-items-center">
          <div className="vertical-line"></div>
        </div>
        <Button disabled={!feed.status} className="p-3">
          <Link
            to={`/admin/companies/${projectState.companyId}/projects/${projectState.projectId}/data_sources/${feed.id}/details`}>
            Details
          </Link>
        </Button>
      </ButtonGroup>
    </div>
  </td>
));

SettingsColumn.propTypes = {
  feed: PropTypes.object.isRequired,
  projectState: PropTypes.object.isRequired
};

export default SettingsColumn;
